/**
 * Adds a specified number of months to a given date.
 * @param date The starting date.
 * @param months The number of months to add (can be negative).
 * @returns A new Date object with the months added.
 */
export function addMonths(date: Date, months: number): Date {
  const result = new Date(date);
  result.setMonth(result.getMonth() + months);
  // Handle cases where the day of the month might change (e.g., Jan 31 + 1 month = Feb 28/29)
  // If the original day was, e.g., 31, and the new month doesn't have 31 days,
  // setMonth will roll over. To counteract, if the new day isn't what we expect for that month
  // set to the last day of the *previous* month to effectively get the last day of the target month.
  // However, a simpler approach for loan calculations is often just to let setMonth handle it,
  // as specific day of month is less critical than consistent month advancement.
  // For this use case, the default behavior of setMonth is usually sufficient.
  return result;
}

/**
 * Formats a Date object into 'YYYY-MM' string format.
 * @param date The date to format.
 * @returns A string in 'YYYY-MM' format.
 */
export function formatDateYYYYMM(date: Date): string {
  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, '0'); // getMonth() is 0-indexed
  return `${year.toString()}-${month}`;
}
